import { useRouter } from 'next/router'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Layout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

export const CookieManagementPage = () => {
  const router = useRouter()

  const declineCookie = () => {
    document.cookie = `cookieAccept=false; max-age=31536000; path=/;`
    router.push('/')
  }

  return (
    <>
      <Head title="Cookie管理" description="" noindex />
      <CustomLayout>
        <Layout>
          <Content>
            <StyledButton onClick={declineCookie}>
              Cookieのご利用を停止する
            </StyledButton>
          </Content>
        </Layout>
      </CustomLayout>
    </>
  )
}

const CustomLayout = styled.div`
  > footer {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
`

const Content = styled.div`
  margin: 80px auto 0;
  width: 1040px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 0 20px;
  }
`

const StyledButton = styled.button`
  color: ${theme.colors.trialBlue};
  background: none;
  border: none;
  font-size: 16px;
  text-decoration: underline;

  &:hover {
    color: ${theme.colors.hoverLightBlue};
  }
`
